import { ReactNode, useMemo } from 'react';
import { usePrevious } from 'react-use';
import { AnimatePresence, motion } from 'framer-motion';

type CarouselProps = {
  currentIndex: number;
  children?: ReactNode[];
  itemClassName?: string;
};

const motionVariants = {
  enter: (dir: number) => ({ x: dir > 0 ? '10%' : '-10%', opacity: 0 }),
  active: { x: 0, opacity: 1 },
  exit: (dir: number) => ({ x: dir < 0 ? '10%' : '-10%', opacity: 0 }),
};

export const Carousel = ({ currentIndex, children = [], itemClassName }: CarouselProps) => {
  const prevIndex = usePrevious(currentIndex);
  const direction = useMemo(() => currentIndex - (prevIndex ?? 0), [currentIndex, prevIndex]);

  return (
    <AnimatePresence mode="wait" initial={false} custom={direction}>
      <motion.div
        key={currentIndex}
        custom={direction}
        variants={motionVariants}
        initial="enter"
        animate="active"
        exit="exit"
        transition={{ duration: 0.1 }}
        className={itemClassName}
      >
        {children[currentIndex]}
      </motion.div>
    </AnimatePresence>
  );
};
